import React from 'react';
import { companyInfo } from '../data/mock';

const Datenschutz = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-white mb-4">Datenschutzerklärung</h1>
          <p className="text-slate-300">Informationen zur Verarbeitung Ihrer Daten</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-semibold text-slate-900 mb-4">1. Datenschutz auf einen Blick</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">Allgemeine Hinweise</h3>
            <p className="text-slate-600 mb-6">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
              persönlich identifiziert werden können.
            </p>

            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">Datenerfassung auf dieser Website</h3>
            <p className="text-slate-600 mb-6">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber:<br /><br />
              {companyInfo.name}<br />
              {companyInfo.owner}<br />
              {companyInfo.address}<br />
              E-Mail: {companyInfo.email}<br />
              Telefon: {companyInfo.phone}
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">2. Hosting</h2>
            <p className="text-slate-600 mb-6">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter: Der Hoster erhebt in sog. Logfiles 
              folgende Daten, die Ihr Browser übermittelt: IP-Adresse, die Adresse der vorher besuchten Website 
              (Referer Anfrage-Header), Datum und Uhrzeit der Anfrage, Zeitzonendifferenz zur Greenwich Mean Time, 
              Inhalt der Anforderung, HTTP-Statuscode, übertragene Datenmenge, Website, von der die Anforderung kommt 
              und Informationen zu Browser und Betriebssystem.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">Datenschutz</h3>
            <p className="text-slate-600 mb-6">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie 
              dieser Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">Hinweis zur verantwortlichen Stelle</h3>
            <p className="text-slate-600 mb-6">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              {companyInfo.name}<br />
              {companyInfo.owner}<br />
              {companyInfo.address}<br /><br />
              Telefon: {companyInfo.phone}<br />
              E-Mail: {companyInfo.email}
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">4. Datenerfassung auf dieser Website</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">Kontaktformular</h3>
            <p className="text-slate-600 mb-6">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
              von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              <br /><br />
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage 
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen 
              erforderlich ist.
            </p>

            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">Cookies</h3>
            <p className="text-slate-600 mb-6">
              Unsere Internetseiten verwenden so genannte "Cookies". Cookies sind kleine Datenpakete und richten auf 
              Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung 
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">5. Ihre Rechte</h2>
            <p className="text-slate-600 mb-6">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
              gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder 
              Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, 
              können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter 
              bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
              <br /><br />
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mb-4 mt-8">6. SSL- bzw. TLS-Verschlüsselung</h2>
            <p className="text-slate-600 mb-6">
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum 
              Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. 
              TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des 
              Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;
